<template>
  <div class="cp-section">
    <OrderList v-if="isCustomerPortalOrderList" :input="input" title="Orders & Subscriptions" :params="params" @submit="submit" />
    <OrderDetail v-else-if="isCustomerPortalOrderDetail" @submit="selectInput"
                 :input="input" :side-menus="sideMenus"/>
  </div>
</template>

<script>
import {FulfillmentStatus, InputType, ItemStatus} from '@/constants'
import {mapState} from 'vuex'

const OrderList = () => import('./../Order/OrderList')
const OrderDetail = () => import('./../Order/OrderDetail')

export default {
  name: 'CustomerPortalOrders',
  components: {OrderList, OrderDetail},
  props: {
    input: Object,
    sideMenus: Array
  },
  data: function() {
    return {
      params: {
        is_active: false,
        'status__in!': [ItemStatus.Declined, ItemStatus.Complete].join(','),
        'fulfillment_status__in!': [FulfillmentStatus.Cancelled, FulfillmentStatus.Delivered, FulfillmentStatus.Skipped, FulfillmentStatus.Removed].join(',')
      }
    }
  },
  computed: {
    ...mapState(['session']),
    isCustomerPortalOrderList: function() {
      return this.session && this.session['step_type'] === InputType.CustomerPortalOrders
    },
    isCustomerPortalOrderDetail: function() {
      return this.session && this.session['step_type'] === InputType.CustomerPortalOrderDetail
    }
  },
  methods: {
    submit: function(input) {
      this.$emit('submit', input)
    },
    selectInput: function(data) {
      this.$emit('selectItem', data)
    }
  }
}
</script>

<style scoped>

</style>
